import React from "react";

type FilterType = 'all' | 'receipt' | 'itemized-bill'

interface ReceiptSearchNavigationProps {
  fuseSearch?: {
    search: (query: string) => void,
    query: string | undefined
  }
  filter?: {
    value: FilterType,
    onChange: (filter: FilterType) => void
  }
}

export function ReceiptSearchNavigation({
  fuseSearch,
  filter
}: ReceiptSearchNavigationProps) {
  return (
    <form className="row mb-4" onSubmit={(e) => e.preventDefault()}>
      <div className='col-12 col-lg-6'>
        <label className='form-label me-auto'><strong>Search Attachments</strong></label>
        {fuseSearch &&
          <input 
            className="form-control" 
            type="search" 
            placeholder="Provider, document, or amount" 
            aria-label="Search attachments"
            value={fuseSearch.query || ''}
            onChange={(e) => { e.preventDefault(); fuseSearch.search(e.target.value) }} 
          />}
      </div>
      
      {filter && (
        <div className='col-12 col-lg-6 mt-1'>
          <select 
            className="form-select" 
            value={filter.value} 
            onChange={(e) => filter.onChange(e.target.value as FilterType)}
            aria-label="Filter attachments by type"
          >
            <option value="all">All Items</option>
            <option value="receipt">Receipts Only</option>
            <option value="itemized-bill">Itemized Bills Only</option>
          </select>
        </div>
      )}
    </form>
  )
}